"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _AVNURAH2cjs = require('../__chunks/AVNURAH2.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');
require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/select/select-value.tsx
function SelectValue({
  store,
  fallback,
  children
} = {}) {
  const context = _AVNURAH2cjs.useSelectContext.call(void 0, );
  store = store || context;
  const value = _FH6HQ5JNcjs.useStoreState.call(void 0, store, (state) => {
    if (!(state == null ? void 0 : state.value.length)) return fallback;
    return state.value;
  });
  if (children) {
    return children(value || "");
  }
  return value;
}


exports.SelectValue = SelectValue;
